<template>
  <modal v-if="isOpened" :is-opened="isOpened" :on-close="close" class="virtualvisit__modal virtualvisit-modal">
    <template #header>
      <div class="virtualvisit-modal__header virtualvisit-modal-header">
        {{ trans('office_offer.virtualvisit.modal_title') }}
      </div>
    </template>
    <template #body>
      <div class="virtualvisit-modal__body">
        <iframe :src="link" frameborder="0" height="100%" sandbox="allow-scripts allow-same-origin" />
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@components/Modal.vue';
import translation from '@elements/translation';
import eventBus from '@tools/event-bus';

/**
 * Virtual visit Component
 * This component use the modal component as a child.
 */
export default {
  components: { Modal },
  mixins: [ translation ],
  props: {
    isOpened: { type: Boolean, default: false },
    link: { type: String, default: '' },
  },
  mounted() {
    eventBus.addEventListener('close-modal', () => this.close());
  },
  methods: {
    /**
     * Emit close event to the parent <virtualvisit> on button close click
     */
    close() {
      this.$emit('close');
    },
  },
};
</script>
